import React from "react";

// Kapsam seçicisi (Tümü / Bayim / Müşterilerim) tüketim kartına, dönem
// butonlarının altına taşındı (ScopeSwitch) — kapsam o kartın verisini süzüyor.
export default function DealerDashboardHeader({ isLoading = false }) {
  return (
    // Kart dili sayfanın geri kalanıyla aynı: beyaz zemin + gray-200 border +
    // shadow-sm (bkz. shared/StatCard). Maskot ve ona bağlı durum rozeti
    // kaldırıldı — sayfadan kopuk duruyordu ve sağda 44'e kadar boşluk
    // rezerve ettiriyordu.
    <div className="relative z-30 bg-white rounded-none sm:rounded-2xl shadow-sm border-b sm:border border-gray-200">
      <div className="px-3 py-3 sm:px-4 sm:py-4 lg:px-5">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
          {/* Sol: başlık */}
          <div className="flex items-center gap-2.5 sm:gap-3 min-w-0">
            <div className="shrink-0 p-2 sm:p-2.5 bg-blue-50 border border-blue-100 rounded-xl">
              <svg
                className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                />
              </svg>
            </div>
            <div className="min-w-0">
              <div className="flex items-center gap-2">
                <h1 className="text-base sm:text-xl font-Bold text-gray-900 truncate">
                  Dashboard
                </h1>
                {/* Yükleniyor göstergesi maskottan buraya taşındı — başlığın
                    yanında sessiz bir nokta, sayfayı zıplatmıyor. */}
                {isLoading && (
                  <span className="inline-flex items-center gap-1.5 text-[11px] font-Medium text-gray-400">
                    <span className="w-3 h-3 rounded-full border-2 border-gray-200 border-t-blue-500 animate-spin" />
                    <span className="hidden sm:inline">Güncelleniyor</span>
                  </span>
                )}
              </div>
              <p className="hidden sm:block text-gray-500 text-sm">
                Tüketim ve performans analizi
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
